import { render, staticRenderFns } from "./ProductQuestionCreate.vue?vue&type=template&id=78f3c1bf&"
import script from "./ProductQuestionCreate.vue?vue&type=script&lang=js&"
export * from "./ProductQuestionCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuestionCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports